var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbMajor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    fill: "#ff5400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 4l3.14 5.5H3.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14a7 7 0 10-7-7 7 7 0 007 7zm.43-11.25a.49.49 0 00-.86 0l-4 7a.5.5 0 000 .5.48.48 0 00.43.25h8a.48.48 0 00.43-.25.5.5 0 000-.5z",
    fillRule: "evenodd"
  })))));
}

export default SvgCustomDnbMajor;